<template>
  <b-card no-body class="mt-6">
    <b-modal
      id="add-volunteer"
      hide-header
      class="cust-app-modal popupwidth"
      hide-footer
    >
      <addVolunteerpopup :getVolunteer="getVolunteer" />
    </b-modal>
    <b-modal
      id="edit-volunteer"
      hide-header
      class="cust-app-modal popupwidth"
      hide-footer
    >
      <editVolunteerpopup :selectedItemId="selectedItemId" />
    </b-modal>
    <div class="flex mt-12 mb-12 px-2 justify-between gap-4">
      <div class="flex w-full">
        <b-input-group class="w-full">
          <b-form-input
            v-model="search"
            class="border-none shadow-lg ml-4"
            type="text"
            min="0.00"
            placeholder="Enter Search...."
            @input="getVolunteer"
          ></b-form-input>

          <b-input-group-append>
            <b-button
              variant="white"
              class="flex items-center shadow-lg"
              aria-label="search"
              @click="getVolunteer"
            >
              <feather-icon
                class="cursor-pointer mr-2"
                icon="SearchIcon"
                svgClasses="w-4 h-4"
              ></feather-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div class="flex justify-between gap-4">
        <base-button
          type="primary"
          outline
          class="px-2 py-2 mx-1 flex items-center"
        >
          <download-excel
            class="mr-1 flex"
            default-value=""
            :fetch="fetchData"
            :fields="json_fields"
            worksheet="My Worksheet"
            name="UserList.xls"
          >
            <feather-icon icon="UploadIcon" class="mr-2 cust-HW"></feather-icon
            >Export
          </download-excel>
        </base-button>
        <base-button
          v-b-modal.add-volunteer
          type="primary"
          outline
          class="px-2 py-2 mx-1 flex items-center"
        >
          <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Add
        </base-button>
      </div>
    </div>
    <el-table
      class="table-responsive table-flush mx-4"
      header-row-class-name="thead-light table-th-color "
      :data="user"
      border
    >
      <el-table-column
        label="Sr no"
        min-width="120px"
        prop="srno"
        sortable
      ></el-table-column>
      <el-table-column label="Name" min-width="220px" prop="name" sortable>
      </el-table-column>
      <el-table-column
        label="Phone Number"
        prop="mobile"
        min-width="150px"
        sortable
      >
      </el-table-column>

      <el-table-column label="Email ID" prop="email" min-width="150px" sortable>
      </el-table-column>

      <el-table-column
        label="Status"
        min-width="150px"
        v-slot="{ row }"
        prop="status"
        sortable
      >
        <base-button
          v-if="row.status === true"
          type="primary"
          class="px-6 py-1 mx-1 flex items-center h-10 ml-4"
          @click="handleStatus(false, row.sessionId)"
        >
          Active
        </base-button>
        <base-button
          v-if="row.status === false"
          type="primary"
          class="px-4 py-1 mx-1 flex items-center h-10 ml-4 bg-FF3D3D"
          @click="handleStatus(true, row.sessionId)"
        >
          In-active
        </base-button>
      </el-table-column>

      <el-table-column
        label="Actions"
        v-slot="{ row }"
        min-width="150px"
        sortable
      >
        <div class="flex justify-center items-center">
          <feather-icon
            v-b-modal.edit-volunteer
            icon="EditIcon"
            svgClasses="w-6 text-blue-500 cursor-pointer"
            class="mr-2"
            @click="handleEdit(row.item)"
          ></feather-icon>
          <!-- <feather-icon
                  icon="Trash2Icon"
                  svgClasses="w-6 text-red-600 cursor-pointer"
                  @click="handleDelete(scope)"
                ></feather-icon> -->
        </div>
      </el-table-column>

      <!-- <el-table-column
        label="Session ID"
        min-width="150px"
        prop="sessionId"
        sortable
      ></el-table-column> -->
    </el-table>
    <b-card-footer class="py-4 d-flex justify-content-end">
      <!-- <base-pagination
        @change="
          (value) => {
            currentPage = value;
            dataload();
          }
        "
        :per-page="perPage"
        :total="total_row"
      ></base-pagination> -->
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
      ></b-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
import { mapState } from "vuex";
import addVolunteerpopup from "./add-volunteerpopup.vue";
import editVolunteerpopup from "./edit-volunteerpopup .vue";

export default {
  components: {},
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    addVolunteerpopup,
    editVolunteerpopup,
  },

  computed: {
    toggled() {
      return this.userToggle;
    },
    ...mapState("respitecare", ["get_volunteer_by_admin"]),
  },
  watch: {
    async currentPage() {
      await this.getVolunteer();
    },
  },
  data() {
    return {
      userToggle: false,
      search: "",
      currentPage: 1,
      user: [
        // {
        //   srno: 1,
        //   name: "fsedfs",
        //   mobile: 9865321478,
        //   email: "megha.bhagirath@aiab.in",
        //   status: "active",
        //   sessionId: 1,
        // },
      ],
      totalRows: 0,
      perPage: 5,
      selectedItemId: "",
    };
  },
  computed: {
    ...mapState("respitecare", {
      get_volunteer_by_admin: "get_volunteer_by_admin",
    }),
    json_fields() {
      return {
        name: "name",
        email: "email",
        mobile_no: "mobile",
        status: "status",
        // session_Id: "sessionId",
        // created_at: {
        //   field: "createdAt",
        //   callback: (date) => {
        //     return new Date(date).toDateString();
        //   },
        // },
      };
    },
  },
  methods: {
    async fetchData() {
      let payload = {
        limit: this.totalRows,
        isAdminApprove: true,
      };

      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch(
          "respitecare/get_volunteer_by_admin",
          payload
        );
        if (data.code == 200) {
          loader.close();
          this.$swal({
            // title: "No Selection!",
            html: `<p class="text-center">Data has been successfully exported!</p>`,
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
            // confirmButtonText: "Yes, delete it!",
          });
          const users = data.data[0].result.map((user, index) => {
            if (user.userId[0]) {
              return {
                // srno: index + 1 + curPage * this.perPage,
                name:
                  user.userId[0].firstname && user.userId[0].lastname
                    ? user.userId[0].firstname + " " + user.userId[0].lastname
                    : "",
                mobile: user.userId[0].mobile ? user.userId[0].mobile : "",
                email: user.userId[0].email ? user.userId[0].email : "",
                status: user.isActive ? "Active" : "In-active",
                sessionId: user._id,
              };
            }
          });
          return users;
        }
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    async handleStatus(currStatus, id) {
      let payload = {
        volunteerId: id,
        isActive: currStatus,
      };

      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch(
          "respitecare/editvolunteer",
          payload
        );
        if (data.code == 200) {
          loader.close();
          this.$swal({
            // title: "No Selection!",
            html: `<p class="text-center">Volunteer status updated!</p>`,
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
          await this.getVolunteer();
        }
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    async getVolunteer() {
      let curPage = this.currentPage - 1;
      let payload = {
        limit: this.perPage,
        offset: curPage,
        isAdminApprove: true,
      };
      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      try {
        await this.$store.dispatch(
          "respitecare/get_volunteer_by_admin",
          payload
        );
        await this.$store.dispatch("respitecare/get_all_count");
        const data = this.get_volunteer_by_admin;

        this.totalRows = data[0].totalCount;
        let userdata = data[0].result;
        const users = userdata.map((user, index) => {
          if (user.userId[0]) {
            return {
              _id: user.userId[0]._id,
              item: user,
              srno: index + 1 + curPage * this.perPage,
              name: user.userId[0].firstname ? user.userId[0].firstname : "",
              mobile: user.userId[0].mobile ? user.userId[0].mobile : "",
              email: user.userId[0].email ? user.userId[0].email : "",
              status: user.isActive,
              sessionId: user._id,
            };
          }
        });
        this.user = users;
      } catch (error) {
        console.log(error);
      }
    },
    async handleEdit(value) {
      console.log(value, "VALUEEE");
      this.selectedItemId = value;
    },
  },
  async mounted() {
    await this.getVolunteer();
  },
};
</script>

<style>
.bg-FF3D3D {
  background: #ff3d3d !important;
}
.bg-multi {
  background-color: #f7fafe !important;
  border-color: #f7fafe !important;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.displaynone {
  display: none;
}
.custselect.el-select-dropdown__item.selected {
  color: #606060;
}
</style>
